// extracted by mini-css-extract-plugin
export default {"main":"WhatIs_main__Jy2lN","title":"WhatIs_title__HZxUP","exit":"WhatIs_exit__I1As0","description":"WhatIs_description__BpFX2"};